__turbopack_context__.v({
  "companyPersonSelectFields": "qeZMrW_companyPersonSelectFields",
  "companyPersonSelectFieldsInline": "qeZMrW_companyPersonSelectFieldsInline",
  "companyPersonSelectFieldsStack": "qeZMrW_companyPersonSelectFieldsStack",
});
